/* eslint-disable */
import { Badge, Button, Chip } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { cloneDeep } from 'lodash';
import { Tune } from '@mui/icons-material';
import { formActions, modalActions } from '../../Actions';
import analyticsAction from '../../Actions/analytics.actions';
import AmountContainerDiv from '../../Components/Forms/Payment Settlements/AmountContainerDiv';
import cogsDashboardAnalysisConfig from './bomDashboardAnalysis.config';
import styles from './BOMDashboard.module.scss';
import { Tag } from '../../Components/Tags';
// import QualityAnalysisGraph from '../../Components/Analytics/Quality/QualityAnalysisGraph/QualityAnalysisGraph';
import { QualityStatisticalAnalysis } from '../../Components/Analytics/Quality';
import { classes, fetchList, getProductMapping, useProductData, useQuery } from '../../Helpers';
// import COGSAnalysisGraph from '../../Components/Analytics/COGs/COGSAnalysisGraph/COGSAnalysisGraph';
import { BOMAnalysisGraph } from '../../Components/Analytics/BOM/BOMAnalysisGraph';
import { timeFilterMap } from '../../Constants';
import { SelectPicker } from 'rsuite';
import { useAuth } from '@/Components/Auth/Login/auth';
import RmPriceUpdateModal from '@/Components/Modals/RmPriceUpdateModal/RmPriceUpdate';


const BOMDashboard = (props) => {
	const [state, setState] = useState({
		...cogsDashboardAnalysisConfig.initialState,
	});
	const { appConfig = {} } = useAuth();
	const isA2bCustomer = appConfig?.customerId === 68;
	const isNagaCusotmer = appConfig?.customerId === 72;
	const [internalProductionProductIds, setInternalProductionProductIds] = useState([]);
	const productList = useSelector((state) => state?.form?.ALL_PRODUCTS?.data?.LIST);
	const shifts = useSelector((state) => state?.analytics?.SHIFT_LIST);
	const dispatch = useDispatch();

	const {
		toggleFilterModal,
		geoFilterData,
		dateFilterData,
		geoData,
		storeFilterData,
		applyFilters,
		statFilterData,
		productData,
		stores,
		fetchStoresList,
		data,
		resetFilters,
		analysisFilters,
		setAnalysisDashboardFilters,
		shiftFilterData,
		dateRangeFilter,
		viewTabValue,
	} = props;

	const queryParams = useQuery();
	const queryStoreId = queryParams.get('storeId')
		? Number(queryParams.get('storeId'))
		: null;
	const queryDay = queryParams.get('day')
		? Number(queryParams.get('day'))
		: null;
	const queryMonth = queryParams.get('month')
		? Number(queryParams.get('month'))
		: null;
	const queryYear = queryParams.get('year')
		? Number(queryParams.get('year'))
		: null;
	const dateRange = JSON.parse(queryParams.get('dateRangeFilter'))
	const shiftFilter = Number(queryParams.get('shiftFilter'))
	const toggleValue = queryParams.get('yAxis')

	useEffect(() => {
		setAnalysisDashboardFilters(
			{
				...analysisFilters,
				analysisType: 'BOM',
			},
			false
		);
	}, []);

	useEffect(() => {
		(async () => {
			const productIds = await getProductMapping(13, 920);
			setInternalProductionProductIds(productIds);
		})();
	}, []);

	useEffect(() => {
		if (Array.isArray(productList) && productList?.length === 0) {
			useProductData(dispatch);
		}
		if (Array.isArray(shifts) && shifts?.length === 0) {
			fetchList(dispatch, 'shifts');
		}
	}, [productList, shifts]);

	const getProductData = useMemo(() => {
		const data = [];
		productList?.filter((product) => {
			return product?.skuType === 'PRODUCT' && !product?.isDeleted && !internalProductionProductIds?.includes(product?.id);
		})?.forEach((product) => {
			product?.variants?.forEach((variant) => {
				data.push({
					label: `${product?.productName}(${variant?.displayName})${variant?.clientVariantId ? variant?.clientVariantId : ' '}`,
					value: variant?.id,
				});
			});
		});
		return data;
	}, [productList]);

	const handleParamsFilters = () => {
		const filters = {
			STORE_FILTER: {
				active: false,
				selectedStores: [],
			},
			DATE_FILTER: {
				...dateFilterData,
			},
			SHIFT_FILTER: {
				...shiftFilterData,
			},
			DATE_RANGE_FILTER: {
				...dateRangeFilter,
			},
			Y_AXIS: {
				...viewTabValue,
			},
		};
		if (queryStoreId) {
			filters.STORE_FILTER = {
				active: true,
				selectedStores: [queryStoreId],
			};
		}
		if (queryDay && queryMonth && queryYear) {
			filters.DATE_FILTER = {
				...dateFilterData,
				text: queryDay,
				type: 'day',
				active: true,
				selection: {
					...dateFilterData.selection,
					year: queryYear,
					month: timeFilterMap.month[queryMonth - 1],
					day: queryDay,
				},
			};
		}
		if (!queryDay && queryMonth && queryYear) {
			filters.DATE_FILTER = {
				...dateFilterData,
				text: timeFilterMap.month[queryMonth - 1],
				type: 'month',
				active: true,
				selection: {
					...dateFilterData.selection,
					year: queryYear,
					month: timeFilterMap.month[queryMonth - 1],
					day: null,
				},
			};
		}
		if (!queryDay && !queryMonth && queryYear) {
			filters.DATE_FILTER = {
				...dateFilterData,
				text: queryYear,
				type: 'year',
				active: true,
				selection: {
					...dateFilterData.selection,
					year: queryYear,
					month: null,
					day: null,
				},
			};
		}
		if (shiftFilterData) {
			filters.SHIFT_FILTER = {
				applied: true,
				value: shiftFilter,
			}
		}
		if (dateRange) {
			filters.DATE_RANGE_FILTER = {
				...dateRangeFilter,
				from: new Date(dateRange?.from),
				to: new Date(dateRange?.to),
				active: true,
			}
		}
		if (toggleValue) {
			const value = toggleValue === 'weight' ? 'TotalWeight' : toggleValue === 'cost' ? 'TotalCost' : 'PerUnit';
			filters.Y_AXIS = value
		}
		applyFilters(
			{
				...filters,
			},
			true
		);
	};

	useEffect(() => {
		if (queryDay || queryMonth || queryYear || queryStoreId || shiftFilter || dateRange || toggleValue) {
			handleParamsFilters();
		}
	}, []);

	useEffect(() => {
		let newDateFilter = {
			...dateFilterData,
		};
		if (!queryDay && !queryMonth && !queryYear && !queryStoreId && !shiftFilter && !dateRange && !toggleValue) {
			if (dateFilterData?.active && dateFilterData?.type !== 'month') {
				newDateFilter = {
					...dateFilterData,
					type: 'month',
					active: true,
					selection: {
						...dateFilterData.selection,
						year: new Date().getFullYear(),
						month: timeFilterMap.month[new Date().getUTCMonth()],
						day: null,
						hour: null,
					},
					text: timeFilterMap.month[new Date().getUTCMonth()],
				};
				applyFilters({
					DATE_FILTER: newDateFilter,
				}, true);
			} else if (!dateFilterData?.active) {
				newDateFilter = {
					...dateFilterData,
					active: true,
					selection: {
						...dateFilterData.selection,
						hour: null,
					},
				};
				applyFilters(
					{
						DATE_FILTER: newDateFilter,
					},
					true
				);
			} else {
				newDateFilter = {
					...dateFilterData,
					active: true,
					selection: {
						...dateFilterData.selection,
						hour: null,
					},
				};
				applyFilters(
					{
						DATE_FILTER: newDateFilter,
					},
					true
				);
			}
		}
	}, []);

	const onClickHandler = () => {
		toggleFilterModal(true);
	};
	const delStoreHandler = (storeData) => {
		const updatedStoreId = geoFilterData.store.filter((currStoreId) => {
			return parseInt(storeData.id, 10) !== currStoreId;
		});
		const currCityStores = Object.keys(
			geoData[parseInt(storeData.stateId, 10)].city[
				parseInt(storeData.cityId, 10)
			].store
		).filter((currStoreId) => {
			return geoFilterData.store.includes(parseInt(currStoreId, 10));
		});
		const updatedCityId =
			currCityStores.length > 1
				? geoFilterData.city
				: geoFilterData.city.filter((currCityId) => {
					return currCityId !== parseInt(storeData.cityId, 10);
				});
		const currStateCity = Object.keys(
			geoData[parseInt(storeData.stateId, 10)].city
		).filter((currCityId) => {
			return geoFilterData.city.includes(parseInt(currCityId, 10));
		});
		const updatedStateId =
			currCityStores.length > 1 || currStateCity.length > 1
				? geoFilterData.state
				: geoFilterData.state.filter((currStateId) => {
					return parseInt(storeData.stateId, 10) !== currStateId;
				});
		applyFilters({
			GEO_FILTER: {
				state: updatedStateId,
				city: updatedCityId,
				store: updatedStoreId,
			},
		});
	};

	const delStatHandler = (delId) => {
		const newStatFilterData = cloneDeep(statFilterData);
		newStatFilterData.selectedProductIds =
			newStatFilterData.selectedProductIds.filter((id) => {
				return id !== delId;
			});
		newStatFilterData.selected =
			newStatFilterData.selectedProductIds.length > 0;
		if (!newStatFilterData.selected) {
			newStatFilterData.selectedBrands = [];
		}
		applyFilters({
			STATISTICAL_FILTER: newStatFilterData,
		});
	};

	const totalAppliedFilters =
		(geoFilterData?.store?.length || 0) +
		(storeFilterData?.length || 0) +
		(statFilterData?.selectedProductIds.length || 0);

	const getFilterData = () => {
		const filterData = geoFilterData.state.reduce(
			(accData, currStateId) => {
				const selectedStateCities = Object.keys(
					geoData[currStateId].city
				).filter((currCityId) => {
					return geoFilterData.city.includes(
						parseInt(currCityId, 10)
					);
				});
				const selectedCityStores = selectedStateCities.reduce(
					(accCityStores, currCityId) => {
						const currCityStores = Object.keys(
							geoData[currStateId].city[currCityId].store
						).reduce((accStoreData, currStoreId) => {
							if (
								geoFilterData.store.includes(
									parseInt(currStoreId, 10)
								)
							) {
								const nameAndId = {
									name: geoData[currStateId].city[currCityId]
										.store[currStoreId].name,
									id: currStoreId,
									cityId: currCityId,
									stateId: currStateId,
								};
								accStoreData.push(nameAndId);
							}
							return accStoreData;
						}, []);
						accCityStores.push(...currCityStores);
						return accCityStores;
					},
					[]
				);
				// eslint-disable-next-line no-param-reassign
				accData = [...accData, ...selectedCityStores];
				return accData;
			},
			[]
		);

		return (
			<>
				{totalAppliedFilters > 0 && (
					<Chip
						label='CLEAR ALL'
						onDelete={() => {
							resetFilters([
								'GEO_FILTER',
								'PRODUCT_FILTER',
								'STORE_FILTER',
							]);
						}}
						className='bg-slate-100 text-gray-700 hover:bg-slate-200 transition-colors duration-200 shadow-sm border border-gray-200 rounded-full'
						size='small'
					/>
				)}
				{filterData.map((storeData) => {
					return (
						<Chip
							key={storeData.id}
							label={storeData.name}
							onDelete={() => {
								delStoreHandler(storeData);
							}}
							className='bg-slate-100 text-gray-700 hover:bg-slate-200 transition-colors duration-200 shadow-sm border border-gray-200 rounded-full'
							size='small'
						/>
					);
				})}

				{statFilterData.selected ? (
					statFilterData.selectedProductIds.map((id) => {
						return (
							<Chip
								key={id}
								label={productData?.[id]?.productName ?? ''}
								onDelete={() => {
									delStatHandler(id);
								}}
								className='bg-slate-100 text-gray-700 hover:bg-slate-200 transition-colors duration-200 shadow-sm border border-gray-200 rounded-full'
								size='small'
							/>
						);
					})
				) : (
					<></>
				)}
			</>
		);
	};
	useEffect(() => {
		setState({
			...cogsDashboardAnalysisConfig.serializer(state, data),
		});
	}, [data]);

	const handleProductSelect = (value) => {
		let filter = {
			VARIANT_FILTER: { applied: true, selected: [value] },
			BOM_CHART_VIEW: 'PerUnit',
		}
		if (!value) {
			filter.VARIANT_FILTER = { applied: false, selected: [] }
			filter.BOM_CHART_VIEW = 'TotalWeight'
		}
		applyFilters(filter, true);

	}
	const handleShiftSelect = (value) => {
		let filter = {
			SHIFT_FILTER: { applied: true, value: value }
		}
		if (!value) {
			filter.SHIFT_FILTER = { applied: false, value: null }
		}
		applyFilters(filter, true);
	}

	const renderBody = useMemo(() => {
		// if (statFilterData.selected) {
		// 	return <QualityStatisticalAnalysis />;
		// }

		return (
			<>
				<AmountContainerDiv
					// {...AmountContainerProps}
					boxElements={[
						{
							color: '#73c2fd',
						},
						{
							color: '#66c24d',
						},
						{
							color: '#ed9121',
						},
						{
							color: '#ff6961',
						},
						{
							color: 'rgba(158, 123, 181, 0.5)',
						},
					]}
					amountCaption={state.fields.amountCaption}
				/>
				<BOMAnalysisGraph
					// FILTERS={FILTERS}
					isClear={queryParams.has('clear')}
				/>
			</>
		);
	}, [statFilterData.selected, state.fields?.amountCaption]);

	return (
		<div className={classes(styles.root, 'page')}>
			<div className='flex flex-col'>
				<div className={`${styles['filter-container']}`}>
					<div className={`${styles['button-container']}`}>
						<Badge badgeContent={totalAppliedFilters} color='primary'>
							<Button
								variant='outlined'
								className={`${styles['filter-button']}`}
								onClick={onClickHandler}
							>
								filter
								<Tune fontSize='medium' />
							</Button>
						</Badge>
					</div>
					{isA2bCustomer && (
						<SelectPicker
							placeholder='select Products'
							data={getProductData}
							onChange={handleProductSelect}
							className='w-[300px]'
							menuClassName='w-[300px]'
						/>
					)}
					{(isA2bCustomer || isNagaCusotmer) && (
						<SelectPicker
							placeholder='Select Shift'
							data={(shifts ?? [])?.map((item) => {
								return {
									value: item?.id,
									label: item?.shiftName,
								};
							})}
							value={shiftFilterData?.value}
							onChange={handleShiftSelect}
							className='w-[300px]'
						/>
					)}
				</div>
				<div className='flex items-center gap-2 overflow-x-auto'>
					{getFilterData()}
				</div>
			</div>
			{renderBody}
		</div>
	);
};

const mapStateToProps = (state) => {
	const data = state.analytics.BOM_ANALYTICS.CHART_DATA.statsData;
	const geoData = state.geoData.GEO_DATA.data;
	const geoFilterData = state.analytics.GEO_FILTER;
	const dateFilterData = state.analytics.DATE_FILTER;
	const storeFilterData = state.analytics.STORE_FILTER.selectedStores;
	const shiftFilterData = state.analytics.SHIFT_FILTER;
	const viewTabValue = state.analytics.BOM_CHART_VIEW;
	const dateRangeFilter = state.analytics.DATE_RANGE_FILTER;
	const timeFilterData = state.analytics.TIME_FILTER;
	const statFilterData = state.analytics.STATISTICAL_FILTER;
	const stores = state?.form?.FILTERED_STORES?.data?.LIST;
	const analysisFilters = state.analytics.ANALYSIS_DASHBOARD_FILTERS;
	const { LIST: defects } = state.form.DEFECTS.data;
	const productData = state.product.products;

	return {
		geoData,
		geoFilterData,
		data,
		storeFilterData,
		statFilterData,
		timeFilterData,
		dateFilterData,
		stores,
		productData,
		defects,
		analysisFilters,
		shiftFilterData,
		dateRangeFilter,
		viewTabValue,
	};
};
const mapDispatchToProps = {
	toggleFilterModal: modalActions.toggleFilterModal,
	setGeoData: analyticsAction.setGeoData,
	fetchData: analyticsAction.gateway,
	applyFilters: analyticsAction.applyFilters,
	fetchStoresList: formActions.gateway,
	setAnalysisDashboardFilters: analyticsAction.setAnalysisDashboardFilters,
	resetFilters: analyticsAction.resetFilters,
};
export default connect(mapStateToProps, mapDispatchToProps)(BOMDashboard);
